import * as React from "react";
import { StatusFilterPills } from "./StatusFilterPills";
import { DashboardFilters } from "./DashboardFilters";
import type { UseDashboardViewState } from "../hooks";
import type { DashboardLineView } from "@/types/dashboard.types";

interface Props {
  lines: DashboardLineView[];
  visibleIds: string[];
  visibleCount: number;
  view: UseDashboardViewState;
}

export function DashboardSectionBar({
  lines,
  visibleIds,
  visibleCount,
  view,
}: Props): React.ReactElement {
  const responsibles = React.useMemo(
    () =>
      Array.from(new Set(lines.map((l) => l.responsible).filter((r): r is string => !!r))).sort(),
    [lines]
  );

  return (
    <div className="flex flex-wrap items-center gap-3">
      {}
      <h2 className="text-[17px] font-semibold tracking-[-0.01em] text-text-primary">
        Linhas ativas{" "}
        <span className="text-[14px] font-normal text-text-tertiary">· {visibleCount}</span>
      </h2>

      <StatusFilterPills lines={lines} active={view.statusFilter} onChange={view.setStatusFilter} />

      {}
      <div className="ml-auto">
        <DashboardFilters view={view} responsibles={responsibles} visibleIds={visibleIds} />
      </div>
    </div>
  );
}
